let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ccP4M")).then(() => parcelRequire('2SgQR'));